const allDataconsole = {
    categoryComp : {
        categoryComp1: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/4194777b74f8bf80078c6be1a4ea34e7/razer-wolverine-v2-pro-black-white-category-1920x700-desktop.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/d7d8a5e49e0713010baa91b8c412cdda/razer-gold-768x500-mobile.jpg",
            title:"RAZER WOLVERINE V2 PRO",
            des:"Wireless Pro Gaming Controller for PS5™ and PC",
            lUrl:"/"
        },
        categoryComp2: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/b9e965bfe9e958df22d94e6eaea4dfa6/services-razer-silver.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/b9e965bfe9e958df22d94e6eaea4dfa6/razer-silver-768x500-mobile.jpg",
            title:"RAZER SILVER",
            des:"Razer Silver is the only loyalty rewards program for gamers. <br/> Earn Razer Silver simply by using Razer Gold to make your game purchases or participating in our software and services. Utilize your Razer Silver in exclusive events or use them to redeem exciting rewards—from Razer hardware to digital rewards and discounts.",
            lUrl:"/"
        },
        categoryComp3: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5044606f04fbcc28b98ca2be9b48bc3e/services-gold-pins.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5044606f04fbcc28b98ca2be9b48bc3e/razer-goldpin-768x500-mobile.jpg",
            title:"GOLD PINS",
            des:"Gold PINs are a digital code used to reload Razer Gold wallets or top up participating game credits. <br/> Gold PINs can be purchased at over 5.6 million touchpoints globally, including convenience stores, consumer electronics chains, and department stores.",
        },
        categoryComp4: {
          lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c44ce6aa9d981f08ce3f054e20fa07b2/services-gold-webshop.jpg",
          mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c44ce6aa9d981f08ce3f054e20fa07b2/razer-webshop-768x500-mobile.jpg",
          title:"GOLD WEBSHOP",
          des:"Browse over 42,000 games and entertainment titles in the Gold Webshop. <br/> Recharge on the hottest titles such as PUBG Mobile, Mobile Legends: Bang Bang, Genshin Impact, and many more! Check out our Gold Webshop for the full list of titles.",
          lUrl:"/"
        },
        categoryComp5: {
        lgUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card.jpg",
        mdUrl:"https://assets2.razerzone.com/images/pnx.assets/c126593c168b557f2d7f3f0f596f4364/services-gift-card-mobile.jpg",
        title:"RAZER GIFT CARD - GIVE THE GIFT OF GAMING",
        des:"The Razer Gift Card unlocks the ultimate gifts for any gamer. From gaming peripherals to laptops to apparel, redeem from the largest catalog of Razer gear in the world, including rare and exclusive products only found on Razer.com. Recipients also enjoy 14-day risk free returns, and comprehensive customer support.",
        lUrl:"/"
        },
        categoryComp6: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/services-razer-care.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/cd51cc9a2c8e89918bcce4a6b66132d3/razer-care-768x500-mobile.jpg",
      title:"RAZERCARE",
      des:"Protect your Razer gear with RazerCare—includes extended warranty that covers both mechanical and electrical issues due to normal product usage.",
      lUrl:"/"
      },
      categoryComp7: {
      lgUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      mdUrl:"https://assets2.razerzone.com/images/pnx.assets/5650df732c97f6ce9e0c813fc57b9605/services-razer-id.jpg",
      title:"RAZER ID",
      des:"Gain a competitive advantage and leverage on our support, expertise and community with your Razer ID. Integrated with Razer's services and software, you can gain access to tons of tools with your Razer ID—including buying the best gamer gear on our site, redeeming Razer Silver, saving your personalized configs in Synapse, and more.",
      lUrl:"/"
      },
    },
    topDrawer : {
      data1 : [
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-xboxlogo.svg",
          title: "Xbox",
          link: "/",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-playstationlogo.svg",
          title: "Silver",
          link: "/",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-goldpins.svg",
          title: "Gold PINs",
          link: "/pc",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-goldwebshop.svg",
          title: "Gold Webshop",
          link: "/console",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-giftcards.svg",
          title: "Gift Cards",
          link: "/",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-razercare.svg",
          title: "RazerCare",
          link: "/",
        },
        {
          img: "https://assets2.razerzone.com/images/main-menu/icons/icon-razerid.svg",
          title: "Razer ID",
          link: "/",
        }
      ]
  },
  gridData : {
    gridData1 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-iphone.jpg",
          title:"RAZER KISHI V2 FOR IPHONE",
          des:"Universal Mobile Gaming Controller for iPhone",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-android.jpg",
          title:"RAZER KISHI V2 FOR ANDROID",
          des:"Universal Mobile Gaming Controller for Android",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/41eb073828afa16458823c1b8cd2290c/razer-kishi-category-500x500.jpg",
          title:"RAZER KISHI",
          des:"Make your move with our award-winning universal mobile controller that fits most smartphone devices, designed to bring console-level control and comfort to your on-the-go gaming.",
          link:"/"
        }
      ],
    gridData2 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/0f6664b8e4a2ae4aa934396b22275c5c/razer-hammerhead-tw-pro-category-500x500.jpg",
          title:"RAZER HAMMERHEAD TRUE WIRELESS PRO",
          des:"Take your audio immersion to new heights with THX® Certified true wireless earbuds that deliver breathtaking audio quality and advanced active noise cancellation.",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/0f6664b8e4a2ae4aa934396b22275c5c/razer-opus-category-500x500.jpg",
          title:"RAZER OPUS",
          des:"Savor pure, high-fidelity sound with zero distractions with wireless THX® Certified headphones that feature advanced active noise cancellation for an uninterrupted audio experience.",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/3784260489b65a92a1a7730abde98fec/500x500_thx-onyx.jpg",
          title:"THX ONYX™",
          des:"Portable DAC Headphone Amplifier",
          link:"/"
        }
      ],
    gridData3 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-iphone.jpg",
          title:"RAZER KISHI V2 FOR IPHONE",
          des:"Universal Mobile Gaming Controller for iPhone",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-android.jpg",
          title:"RAZER KISHI V2 FOR ANDROID",
          des:"Universal Mobile Gaming Controller for Android",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/41eb073828afa16458823c1b8cd2290c/razer-kishi-category-500x500.jpg",
          title:"RAZER KISHI",
          des:"Make your move with our award-winning universal mobile controller that fits most smartphone devices, designed to bring console-level control and comfort to your on-the-go gaming.",
          link:"/"
        }
      ],
    gridData4 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-iphone.jpg",
          title:"RAZER KISHI V2 FOR IPHONE",
          des:"Universal Mobile Gaming Controller for iPhone",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/fb8fbcd93487d2645e7a64470407dbaf/500x500_kishi-v2-for-android.jpg",
          title:"RAZER KISHI V2 FOR ANDROID",
          des:"Universal Mobile Gaming Controller for Android",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/41eb073828afa16458823c1b8cd2290c/razer-kishi-category-500x500.jpg",
          title:"RAZER KISHI",
          des:"Make your move with our award-winning universal mobile controller that fits most smartphone devices, designed to bring console-level control and comfort to your on-the-go gaming.",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/41eb073828afa16458823c1b8cd2290c/razer-kishi-category-500x500.jpg",
          title:"RAZER KISHI",
          des:"Make your move with our award-winning universal mobile controller that fits most smartphone devices, designed to bring console-level control and comfort to your on-the-go gaming.",
          link:"/"
        },
      ],
},
}


export default allDataconsole